import MultiPanelsNanoPopup from "./MultiPanelsNanoPopup";
import RestPromise from "../../utils/RestPromise";
import JQuery from "jquery";
import "../../../resources/less/components/Popups/informationPagePopup.less";
import "../../../resources/less/Admin/theme.less";
import { TInformationPageTranslation } from "../../Support/Types/TInformationPageTranslation";
import { TInformationPage } from "../../Support/Types/TInformationPage";

export default class InformationPagePopup extends MultiPanelsNanoPopup {
  private readonly mainTitle: JQuery<HTMLHeadingElement>;
  private readonly mainContent: JQuery<HTMLDivElement>;
  private currentPage?: TInformationPage = null;
  private currentTranslation?: TInformationPageTranslation = null;
  private readonly acceptButton: JQuery<HTMLButtonElement>;
  private readonly continueButton: JQuery<HTMLButtonElement>;
  private readonly logoutButton: JQuery<HTMLButtonElement>;
  private readonly closeButton: JQuery<HTMLButtonElement>;
  private readonly isSupportDemo: boolean = false;
  private isMandatory = false;

  constructor() {
    super({
      target: ".information-page-popup",
    });
    this.mainTitle = $(".info-page-title");
    this.mainContent = $(".info-page-content");
    this.acceptButton = $(".admin-popup-accept");
    this.continueButton = $(".admin-popup-continue");
    this.logoutButton = $(".admin-popup-logout");
    this.closeButton = $(".close-info-page");
    this.toggleButtons(0);

    this.acceptButton.on("click", () => {
      this.acceptUserAgreement();
    });
    this.closeContainer.off().on("click", () => {
      this.close();
    });
    this.logoutButton.off().on("click", () => {
      this.close();
    });
    this.isSupportDemo = window.location.href.includes("/support/");
  }

  private static _instance: InformationPagePopup;

  static get instance(): InformationPagePopup {
    if (this._instance === undefined) {
      this._instance = new InformationPagePopup();
    }
    return this._instance;
  }

  public async Display(translationPageId: number): Promise<void> {
    const result = await RestPromise.Create(
      `/rest/information-page/translation/${translationPageId}`,
      "GET",
    );
    this.currentTranslation = result.translation;
    this.currentPage = result.page;
    this.mainTitle.text(result.translation.name);
    this.mainContent.html(
      `${result.translation.popup_content ?? ""}\n${
        this.currentTranslation.common_content
      }`,
    );
    this.isMandatory = result.page.is_legal_document && !this.isSupportDemo;
    this.config.disabledBackPanel = result.page.is_legal_document;
    if (result.page.is_legal_document) {
      this.goTo(0);
      this.toggleButtons(0);
      this.closeButton.addClass("hide");
    } else {
      this.goTo(1);
      this.toggleButtons(1);
      this.closeButton.removeClass("hide");
    }
    super.Show();
    return result;
  }

  public override Hide() {
    super.Hide();
    this.logoutButton.addClass("hide");
    this.acceptButton.addClass("hide");
    this.continueButton.addClass("hide");
    this.goTo(0);
  }

  protected onStateChange(event: JQuery.ClickEvent) {
    if (this.currentStep === 1) {
      this.Hide();
    }
    this.goTo(1);
    this.toggleButtons(1);
  }

  private toggleButtons(step?: number) {
    if (step === 1 && this.currentPage.is_legal_document) {
      if (this.isMandatory) {
        this.logoutButton.removeClass("hide");
      }
      this.acceptButton.addClass("disabled");
      this.acceptButton.removeClass("hide");
      this.continueButton.addClass("hide");
      const timer = setTimeout(() => {
        this.acceptButton.removeClass("disabled");
        clearTimeout(timer);
      }, 2500);
    } else {
      this.logoutButton.addClass("hide");
      this.acceptButton.addClass("hide");
      this.continueButton.removeClass("hide");
    }
  }

  private acceptUserAgreement(): void {
    this.Hide();
    if (this.isSupportDemo) {
      return;
    }
    RestPromise.Create("/rest/information-page/accept-user-agreement", "POST");
  }

  private close(): void {
    if (this.isMandatory) {
      window.location.href = "/logout";
      return;
    }
    this.Hide();
  }
}
